import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Constellation } from "@/components/Constellation";
import { Home } from "@/components/Home";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <div className="aurora" />
      <Constellation />
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
